import DOMPurify from 'isomorphic-dompurify';
import dynamic from 'next/dynamic';
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import SizeHelpButton from '@/components/buttons/size-help';
import UnitFilterButton from '@/components/buttons/unit-filter';
import HeaderFooterContext from '@/context/HeaderFooterContext';
import {
  featuredData,
  filterUnitsDataByfeatures,
  filterUnitsDataWithSize,
  hasIndoorParkingUnits,
  isIndoorParking,
  isParking,
  removeIndoorParkingUnitsData,
  removeUnitsDataWithSize,
} from '@/helper/filterlogicInfo';
import { DEFAULT_FACILITY_ID } from '@/utils/constants';

import CallbackModal from '../callback-modal/requestcallback-modal';
import Loader from './loading';
import NoUnitsFacility from './no-units-facility';
import OutdoorUnits from './outdoor-units';
import UnitSection from './unit-section';

const ShopSection = dynamic(() => import('./shop-section'));
const UnitFilterCard = dynamic(() => import('./unit-filter-card'));
const UnitFilterPop = dynamic(() => import('./unit-filter-popup'));

const UnitsFilter = (props: any) => {
  const headerFooterData = useContext(HeaderFooterContext);
  const { brandRelatedData, uniqueUnitTypes, UnitsData } = props;
  const [featuredChecked, setfeaturedChecked] = useState(false);
  const [smallChecked, setsmallChecked] = useState(false);
  const [mediumChecked, setmediumChecked] = useState(false);
  const [largeChecked, setlargeChecked] = useState(false);
  const [heatedChecked, setHeatedChecked] = useState(false);
  const [climateControlledChecked, setClimateControlledChecked] =
    useState(false);
  const [driveupChecked, setDriveUpChecked] = useState(false);
  const [parkingChecked, setParkingChecked] = useState(false);
  const [indoorcarChecked, setindoorcarChecked] = useState(false);
  const [xlargeChecked, setXlargeChecked] = useState(false);
  const [officeChecked, setOfficeChecked] = useState(false);
  const [smallUnitsData, setsmallUnitsData] = useState<any[]>([]);
  const [mailboxUnitsData, setMailboxUnitsData] = useState<any[]>([]);
  const [largeUnitsData, setlargeUnitsData] = useState<any[]>([]);
  const [mediumUnitsData, setmediumUnitsData] = useState<any[]>([]);
  const [xLargeUnitsData, setxLargeUnitsData] = useState<any[]>([]);
  const [parkingUnitsData, setparkingUnitsData] = useState<any[]>([]);
  const [officeUnitsData, setofficeUnitsData] = useState<any[]>([]);
  const [featurefilterData, setfeaturefilterData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [indoorcarBlur, setindoorcarBlur] = useState(false);
  const [nothingChecked, setNothingChecked] = useState(false);
  const [facilityLoader, setFacilityLoader] = useState(true);
  const [filterDot, setFilterDot] = useState(false);
  const parkingBlur = !isParking(UnitsData);

  const unitInfo = headerFooterData.viewUnitInfo;
  const facilityId = unitInfo.facilityID
    ? unitInfo.facilityID
    : DEFAULT_FACILITY_ID;
  useEffect(() => {
    setsmallChecked(false);
    setmediumChecked(false);
    setlargeChecked(false);
    setHeatedChecked(false);
    setDriveUpChecked(false);
    setClimateControlledChecked(false);
    setParkingChecked(false);
    setindoorcarChecked(false);
    setXlargeChecked(false);
    setOfficeChecked(false);
  }, [props]);

  useEffect(() => {
    setfeaturedChecked(true);
    setfeaturefilterData(featuredData(UnitsData));
    setFinalData(featuredData(UnitsData));
    setindoorcarBlur(!hasIndoorParkingUnits(UnitsData));
  }, [UnitsData]);

  useEffect(() => {
    const smallUnits = filterUnitsDataWithSize(finalData, 'Small');
    const largeUnits = filterUnitsDataWithSize(finalData, 'Large');
    const mediumUnits = filterUnitsDataWithSize(finalData, 'Medium');
    const officeUnits = filterUnitsDataWithSize(finalData, 'office');
    const xLargeUnits = filterUnitsDataWithSize(finalData, 'xLarge');
    const outdoorUnits = filterUnitsDataWithSize(finalData, 'parking');
    const mailUnits = filterUnitsDataWithSize(finalData, 'mailbox');
    setsmallUnitsData(smallUnits);
    setlargeUnitsData(largeUnits);
    setmediumUnitsData(mediumUnits);
    setxLargeUnitsData(xLargeUnits);
    setparkingUnitsData(outdoorUnits);
    setofficeUnitsData(officeUnits);
    setMailboxUnitsData(mailUnits);

    if ((finalData && finalData.length) || UnitsData?.length === 0) {
      setFacilityLoader(false);
    }
  }, [finalData]);

  useEffect(() => {
    if (
      smallChecked ||
      mediumChecked ||
      largeChecked ||
      parkingChecked ||
      indoorcarChecked ||
      xlargeChecked ||
      officeChecked ||
      featuredChecked ||
      heatedChecked ||
      driveupChecked ||
      climateControlledChecked
    ) {
      setFilterDot(true);
    } else {
      setFilterDot(false);
    }
    if (
      !smallChecked &&
      !mediumChecked &&
      !largeChecked &&
      !parkingChecked &&
      !indoorcarChecked &&
      !xlargeChecked &&
      !officeChecked &&
      !featuredChecked
    ) {
      setNothingChecked(true);
      setFinalData(
        filterUnitsDataByfeatures(
          UnitsData,
          heatedChecked,
          driveupChecked,
          climateControlledChecked
        )
      );
    } else if (featuredChecked) {
      setNothingChecked(false);
      setFinalData(
        filterUnitsDataByfeatures(
          featurefilterData,
          heatedChecked,
          driveupChecked,
          climateControlledChecked
        )
      );
    } else if (
      smallChecked ||
      mediumChecked ||
      largeChecked ||
      parkingChecked ||
      indoorcarChecked ||
      xlargeChecked ||
      officeChecked
    ) {
      setNothingChecked(false);
      setFinalData(
        filterUnitsDataByfeatures(
          filteredData,
          heatedChecked,
          driveupChecked,
          climateControlledChecked
        )
      );
    }

    if (heatedChecked || driveupChecked || climateControlledChecked) {
      setfeaturedChecked(false);
    }
  }, [
    smallChecked,
    mediumChecked,
    largeChecked,
    parkingChecked,
    xlargeChecked,
    officeChecked,
    featuredChecked,
    heatedChecked,
    driveupChecked,
    indoorcarChecked,
    climateControlledChecked,
  ]);

  const onCheckBoxClick = (e: any) => {
    const { value, checked } = e.target;
    if (value === 'Featured') {
      setfeaturedChecked(!featuredChecked);
      setsmallChecked(false);
      setlargeChecked(false);
      setmediumChecked(false);
      setXlargeChecked(false);
      setParkingChecked(false);
      setindoorcarChecked(false);
      setHeatedChecked(false);
      setClimateControlledChecked(false);
      setOfficeChecked(false);
      setDriveUpChecked(false);
    }
    if (value === 'Small') {
      setsmallChecked(!smallChecked);
      setfeaturedChecked(false);
    }
    if (value === 'Medium') {
      setmediumChecked(!mediumChecked);
      setfeaturedChecked(false);
    }
    if (value === 'Large') {
      setlargeChecked(!largeChecked);
      setfeaturedChecked(false);
    }
    if (value === 'heated') {
      setHeatedChecked(!heatedChecked);
      setClimateControlledChecked(false);
    }
    if (value === 'climateControlled') {
      setClimateControlledChecked(!climateControlledChecked);
      setHeatedChecked(false);
    }
    if (value === 'driveUp') {
      setDriveUpChecked(!driveupChecked);
    }
    if (value === 'xLarge') {
      setfeaturedChecked(false);
      setXlargeChecked(!xlargeChecked);
    }
    if (value === 'parking') {
      setfeaturedChecked(false);
      setParkingChecked(!parkingChecked);
    }
    if (value === 'indoorcar') {
      setfeaturedChecked(false);
      setsmallChecked(false);
      setlargeChecked(false);
      setmediumChecked(false);
      setXlargeChecked(false);
      setClimateControlledChecked(false);
      setHeatedChecked(false);
      setOfficeChecked(false);
      setDriveUpChecked(false);
      setindoorcarChecked(!indoorcarChecked);
    }
    if (value === 'office') {
      setfeaturedChecked(false);
      setOfficeChecked(!officeChecked);
    }
    if (value === 'clear') {
      setfeaturedChecked(false);
      setsmallChecked(false);
      setlargeChecked(false);
      setmediumChecked(false);
      setXlargeChecked(false);
      setParkingChecked(false);
      setindoorcarChecked(false);
      setOfficeChecked(false);
      setDriveUpChecked(false);
      setHeatedChecked(false);
      setClimateControlledChecked(false);
      setFilteredData(UnitsData);
    }

    if (value === 'Featured' && checked === true) {
      setfeaturefilterData(featuredData(UnitsData));
      setFilteredData([]);
    } else if (featuredChecked === false) {
      setfeaturefilterData([]);
    }
    if (
      value === 'Small' ||
      value === 'Medium' ||
      value === 'Large' ||
      value === 'xLarge' ||
      value === 'parking' ||
      value === 'office'
    ) {
      if (checked) {
        if (indoorcarChecked && value !== 'parking') {
          // remove indoor car storage filter and add the selected filter
          const updatedUnits = removeIndoorParkingUnitsData(filteredData);
          setindoorcarChecked(false);
          setFilteredData([
            ...updatedUnits,
            ...filterUnitsDataWithSize(UnitsData, value),
          ]);
        } else if (indoorcarChecked && parkingChecked) {
          // remove all filters except parking and add the selected filter
          setindoorcarChecked(false);
          setDriveUpChecked(false);
          setHeatedChecked(false);
          setClimateControlledChecked(false);
          const parking = filterUnitsDataWithSize(UnitsData, 'parking');
          setFilteredData([
            ...parking,
            ...filterUnitsDataWithSize(UnitsData, value),
          ]);
        } else {
          // add selected filter
          setFilteredData([
            ...filteredData,
            ...filterUnitsDataWithSize(UnitsData, value),
          ]);
        }
      } else {
        setFilteredData(removeUnitsDataWithSize(filteredData, value));
      }
    }

    if (value === 'indoorcar') {
      if (checked) {
        // reset filteredData
        const indoor = isIndoorParking(UnitsData);
        if (parkingChecked) {
          setFilteredData([
            ...indoor,
            ...filterUnitsDataWithSize(UnitsData, 'parking'),
          ]);
        } else {
          setFilteredData(indoor);
        }
      } else {
        setFilteredData(removeIndoorParkingUnitsData(filteredData));
      }
    }
  };

  return (
    <div>
      <section className="sv-filter-size-guide-responsive d-lg-none">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-12">
              <UnitFilterButton hasFilter={!filterDot} />
            </div>
            <div className="col-md-4 col-12"></div>
            <div className="col-md-4 col-12">
              <SizeHelpButton />
            </div>
          </div>
        </div>
      </section>
      <div className="container">
        <>
          {!facilityLoader ? (
            <div
              className="row gx-3 reverse-flex visible-md"
              style={{ marginTop: '12px' }}
            >
              <div className="col-lg-3 col-md-12 col-12">
                <UnitFilterCard
                  onCheckBoxClick={onCheckBoxClick}
                  featuredChecked={featuredChecked}
                  smallChecked={smallChecked}
                  mediumChecked={mediumChecked}
                  largeChecked={largeChecked}
                  heatedChecked={heatedChecked}
                  climateControlledChecked={climateControlledChecked}
                  driveupChecked={driveupChecked}
                  parkingChecked={parkingChecked}
                  indoorcarChecked={indoorcarChecked}
                  xlargeChecked={xlargeChecked}
                  officeChecked={officeChecked}
                  uniqueUnitTypes={uniqueUnitTypes}
                  parkingBlur={parkingBlur}
                  indoorcarBlur={indoorcarBlur}
                />
                <ShopSection shopStore={brandRelatedData?.Shop_Store} />
                {finalData &&
                finalData?.length &&
                brandRelatedData?.Shop_Store?.Description ? (
                  <div
                    className="card-content"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        brandRelatedData?.Shop_Store?.Description
                      ),
                    }}
                  ></div>
                ) : (
                  ''
                )}
              </div>

              <div className="col-lg-9 col-md-12 col-12 px-0">
                {finalData && finalData?.length ? (
                  <>
                    {smallUnitsData &&
                      (smallChecked || featuredChecked || nothingChecked) && (
                        <UnitSection
                          unitsHeading={
                            <FormattedMessage id="sectionName.small" />
                          }
                          checkName={'Small'}
                          unitsData={smallUnitsData}
                          featuredChecked={featuredChecked}
                          onCheckBoxClick={onCheckBoxClick}
                          heatedChecked={heatedChecked}
                          climateControlledChecked={climateControlledChecked}
                          driveupChecked={driveupChecked}
                          unitsSubHeading={
                            <FormattedMessage id="sectionName.small.info" />
                          }
                        />
                      )}
                    {mediumUnitsData &&
                      (mediumChecked ||
                        featuredChecked ||
                        indoorcarChecked ||
                        nothingChecked) && (
                        <UnitSection
                          checkName={'Medium'}
                          unitsHeading={
                            <FormattedMessage id="sectionName.medium" />
                          }
                          unitsData={mediumUnitsData}
                          featuredChecked={featuredChecked}
                          onCheckBoxClick={onCheckBoxClick}
                          unitsSubHeading={
                            <FormattedMessage id="sectionName.medium.info" />
                          }
                        />
                      )}
                    {largeUnitsData &&
                      (largeChecked ||
                        featuredChecked ||
                        indoorcarChecked ||
                        nothingChecked) && (
                        <UnitSection
                          checkName={'Large'}
                          unitsHeading={
                            <FormattedMessage id="sectionName.large" />
                          }
                          unitsData={largeUnitsData}
                          featuredChecked={featuredChecked}
                          onCheckBoxClick={onCheckBoxClick}
                          unitsSubHeading={
                            <FormattedMessage id="sectionName.large.info" />
                          }
                        />
                      )}
                    {xLargeUnitsData &&
                      (xlargeChecked ||
                        featuredChecked ||
                        indoorcarChecked ||
                        nothingChecked) && (
                        <UnitSection
                          checkName={'xLarge'}
                          unitsHeading={
                            <FormattedMessage id="sectionName.xlarge" />
                          }
                          unitsData={xLargeUnitsData}
                          featuredChecked={featuredChecked}
                          onCheckBoxClick={onCheckBoxClick}
                          unitsSubHeading={
                            <FormattedMessage id="sectionName.xlarge.info" />
                          }
                        />
                      )}
                    {parkingUnitsData &&
                      (parkingChecked || nothingChecked || featuredChecked) && (
                        <OutdoorUnits parkingUnitsData={parkingUnitsData} />
                      )}

                    {officeUnitsData && (officeChecked || nothingChecked) && (
                      <UnitSection
                        checkName={'office'}
                        unitsHeading={'Office Space'}
                        unitsData={officeUnitsData}
                        featuredChecked={featuredChecked}
                        onCheckBoxClick={onCheckBoxClick}
                      />
                    )}

                    {mailboxUnitsData && nothingChecked && (
                      <UnitSection
                        checkName={'mailbox'}
                        unitsHeading={
                          <FormattedMessage id="sectionName.mailbox" />
                        }
                        unitsData={mailboxUnitsData}
                        featuredChecked={featuredChecked}
                        onCheckBoxClick={onCheckBoxClick}
                      />
                    )}

                    <CallbackModal
                      facilityId={facilityId}
                      unitRate={unitInfo.unitRate}
                      unitDimensions={unitInfo.dimensions}
                      ero={true}
                      unitTypeId={unitInfo.unitTypeId}
                      PromotionSLName={unitInfo.PromotionSLName}
                      promotionDescription={unitInfo.promotionDescription}
                      consessionId={unitInfo.consessionId}
                      unitWidth={unitInfo.unitWidth}
                      unitLength={unitInfo.unitLength}
                      formType={unitInfo.formType}
                    ></CallbackModal>
                  </>
                ) : (
                  <NoUnitsFacility onCheckBoxClick={onCheckBoxClick} />
                )}
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </>
        <UnitFilterPop
          onCheckBoxClick={onCheckBoxClick}
          featuredChecked={featuredChecked}
          smallChecked={smallChecked}
          mediumChecked={mediumChecked}
          largeChecked={largeChecked}
          heatedChecked={heatedChecked}
          climateControlledChecked={climateControlledChecked}
          driveupChecked={driveupChecked}
          parkingChecked={parkingChecked}
          indoorcarChecked={indoorcarChecked}
          xlargeChecked={xlargeChecked}
          officeChecked={officeChecked}
          uniqueUnitTypes={uniqueUnitTypes}
          parkingBlur={parkingBlur}
          indoorcarBlur={indoorcarBlur}
        />
      </div>
    </div>
  );
};

export default UnitsFilter;
